import { NotaryContactType } from "../../types/commonTypes/notaryContactType";

export const notaryContactInitialState: NotaryContactType = {
    notaryName: "",
    scpName: "",
    address: "",
    additionalAddress: "",
    postalCode: "",
    city: "",
    cities: [],
}